import React, { useState } from 'react';
import Modal from 'react-modal';

// CSS
import {TerminosCondiciones, StyledModal, Titulo, Texto, Button, Img} from '../Css/StyledForm';
import { Contenedor } from '../Css/StyledHeader';

Modal.setAppElement('#root');

const AyudaPacientesModal = () => {

    const [modalIsOpen, setModalIsOpen] = useState(false);

    return (
        <Contenedor>
            <Img onClick={() => setModalIsOpen(true)} width="37px" src={`/img/icono_ayuda.png`} />
            <TerminosCondiciones onClick={() => setModalIsOpen(true)} >Haz Click para Ayuda</TerminosCondiciones>
            <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)}>
                <StyledModal>
                    <Titulo>Bienvenido a Método Yögen,</Titulo>
                    <Texto>Esta es la pantalla principal, desde donde vas a poder acceder a los distintos apartados de la plataforma.
                    <br/><br/>
                    Si querés probar el Método, hacé clic en el botón “Activar prueba gratis”. Luego, para ingresar, hace click sobre la palabra “usuario de prueba”
                    <br/><br/>
                    Si querés activar una suscripción, hacé clic en tu nombre (arriba a la derecha), seleccioná “Suscripción” y seguí los pasos que se indican.
                    <br/><br/>
                    Para crear un nuevo paciente, hacé clic en el símbolo “+”, completá todos los datos obligatorios y guardá. Recordá que cada correo electrónico debe ser único y estar asignado al rol correspondiente.
                    <br/><br/>
                    Recordá que en el mail de bienvenida vas a encontrar diferentes tutoriales que te guiarán paso a paso para crear un paciente, así como también el acceso al curso de formación en el Método Yögen.
                    <br/><br/>
                    Ante cualquier duda, no dudes en contactarnos. ¡Estamos para ayudarte!
                    </Texto>
                    <div>
                        <Button onClick={() => setModalIsOpen(false)}>Cerrar</Button>
                    </div>
                </StyledModal>
            </Modal>
        </Contenedor>
    );
}
 
export default AyudaPacientesModal;